import React, { useState } from "react";
import { FormField, TextInput, TextArea, Select } from "grommet";
import { useTranslation } from "react-i18next";
import MarkdownMessageEditor from "../../shared/MarkdownMessageEditor";
import { CustomTabs } from "../../shared/CustomTabs";
export default function PushFlowEditor({ value, onChange }) {
  const { t } = useTranslation();
  const [language, setLanguage] = useState(0);
  const update = (field, lang, text) => onChange({ ...value, [field]: { ...value[field], [lang]: text } });
  return <section className="automation-editor-section">
    <h2>{t("automation.pushContent")}</h2>
    <FormField label={t("automation.pushDestination")} htmlFor="push-destination">
      <Select id="push-destination" options={["chat", "magic-link", "url"].map(value => ({ value, label: t(`automation.pushDestinations.${value}`) }))}
        labelKey="label" valueKey={{ key: "value", reduce: true }} value={value.destination}
        onChange={({ value: destination }) => onChange({ ...value, destination,

        })} />
    </FormField>
    {value.destination === "url" && <FormField label={t("automation.pushUrl")} htmlFor="push-url">
      <TextInput id="push-url" type="url" pattern="https?://.+" required placeholder="https://" value={value.url || ""} onChange={event => onChange({ ...value, url: event.target.value })} />
    </FormField>}
    <CustomTabs activeIndex={language} onTabChange={setLanguage} tabs={["en", "fr"].map(lang => ({ key: lang,
      title: t(lang === "en" ? "common.english" : "common.french"), content: <>
        <FormField label={t("automation.pushTitle")} htmlFor={`push-title-${lang}`}>
          <TextInput id={`push-title-${lang}`} maxLength={80} value={value.title?.[lang] || ""} onChange={event => update("title", lang, event.target.value)} />
        </FormField>
        <FormField contentProps={value.destination === "chat" ? { border: false } : undefined} label={t(value.destination === "chat" ? "automation.pushMessage" : "automation.pushDescription")} htmlFor={`push-description-${lang}`}>
          {value.destination === "chat" ? <MarkdownMessageEditor id={`push-description-${lang}`} value={value.body?.[lang] || ""} onChange={text => update("body", lang, text)} /> : <TextArea id={`push-description-${lang}`} maxLength={240} rows={3} value={value.body?.[lang] || ""} onChange={event => update("body", lang, event.target.value)} />}
          {value.destination === "chat" && <p className="automation-editor-hint">{t("automation.pushMessageHelp")}</p>}
        </FormField>
      </> }))} />

  </section>;
}
